// ─── Context ────────────────────────────────────────────────────────────────

export type ScanToPayMachineContext = Readonly<{
  availableCredit: number;
  availablePoints: number;
  paymentMethods: readonly PaymentMethod[];
  pointsRewards: readonly PointsReward[];

  useCredit: boolean;
  paymentMethodId: string;
  identifyToken: string;
  paymentToken: string;
}>;

// ─── Events ─────────────────────────────────────────────────────────────────

export type ScanToPayMachineEvents =
  | StartParams
  | CancelRequestParams
  | RequestAddPaymentParams
  | RequestPaymentSelectionParams
  | SwitchUseCreditParams
  | RequestLoyaltyInfoParams
  | RequestFaqParams
  | RefetchIdentifyTokenParams
  | RefetchPaymentTokenParams
  | RefetchCreditsParams
  | SetDefaultPaymentMethodParams;

// ─── Services ───────────────────────────────────────────────────────────────

export type ScanToPayMachineServices = Readonly<{
  fetchData: {
    data: {
      availableCredit: number;
      availablePoints: number;
      paymentMethods: readonly PaymentMethod[];
      pointsRewards: readonly PointsReward[];
    };
  };
  fetchIdentifyToken: {
    data: {
      identifyToken: string;
    };
  };
  fetchPaymentToken: {
    data: {
      paymentToken: string;
    };
  };
  fetchCredits: {
    data: {
      availableCredit: number;
    };
  };
  setDefaultPaymentMethod: {
    data: {
      paymentMethodId: string;
    };
  };
}>;

// ─── Setup ──────────────────────────────────────────────────────────────────

export type StartParams = { type: 'START' };
export type CancelRequestParams = { type: 'CANCEL_REQUEST' };

// ─── Events ──────────────────────────────────────────────────────────────────

export type RequestAddPaymentParams = {
  type: 'REQUEST_ADD_PAYMENT';
};

export type RequestPaymentSelectionParams = {
  type: 'REQUEST_PAYMENT_SELECTION';
};

export type SwitchUseCreditParams = {
  type: 'SWITCH_USE_CREDIT';
};

export type RequestLoyaltyInfoParams = {
  type: 'REQUEST_LOYALTY_INFO';
};

export type RequestFaqParams = {
  type: 'REQUEST_FAQ';
};

export type RefetchIdentifyTokenParams = {
  type: 'REFETCH_IDENTIFY_TOKEN';
};
export type RefetchPaymentTokenParams = {
  type: 'REFETCH_PAYMENT_TOKEN';
};
export type RefetchCreditsParams = {
  type: 'REFETCH_CREDITS';
};

export type SetDefaultPaymentMethodParams = {
  type: 'SET_DEFAULT_PAYMENT_METHOD';
  params: { paymentMethodId: string };
};

// ─── Entities ────────────────────────────────────────────────────────────────

export type PaymentMethod = {
  id: string;
  description: string | null;
  nickname: string | null;
  isDefault: boolean;
  cardType: PaymentMethodType;
  expirationState: PaymentMethodExpirationState;
};

export enum PaymentMethodType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  MasterCard = 'MASTER_CARD',
  Unsupported = 'UNSUPPORTED',
  Visa = 'VISA',
}

export enum PaymentMethodExpirationState {
  Expired = 'EXPIRED',
  Nearing = 'NEARING',
  Ok = 'OK',
}

export type PointsReward = Readonly<{
  id: string;
  name: string;
  points: number;
  redeemable: boolean;
  assetUrl?: string | null;
}>;
